module.exports = __webpack_public_path__ + "img/trustpilot-badge.b917cce3.svg";